/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { ReactElement, useContext, useState } from 'react'
import { useEffect } from 'react'

import { Tabs } from 'antd'
import moment from 'moment'

import { IJanela } from '../../../Models/docas'
import { DocasContext } from '../Context/context'
import Janela from './Janela'
import Totais from './Totais'

const { TabPane } = Tabs

interface IProps {
  dataSelecionada: moment.Moment
  atualizaAgenda: (
    limparSelecao?: boolean,
    executandoAcao?: boolean,
  ) => Promise<void>
}

const Agenda = ({ dataSelecionada, atualizaAgenda }: IProps): ReactElement => {
  const { docasContext, setDocasContext } = useContext(DocasContext)
  const [janelaSelecionada, setJanelaSelecionada] = useState<string>('0')

  useEffect(() => {
    selecionaJanelaHorarioAtual()
  }, [docasContext.armazemAtual, dataSelecionada])

  const selecionaJanelaHorarioAtual = () => {
    const dataAtual: moment.Moment = moment()

    if (docasContext.armazemAtual?.agendamentoDocasJanelas) {
      if (
        dataSelecionada.format('DD/MM/YYYY') === dataAtual.format('DD/MM/YYYY')
      ) {
        const horaAtual: string = dataAtual.format('HH:00:00')

        for (
          let i = docasContext.armazemAtual.agendamentoDocasJanelas.length - 1;
          i >= 0;
          i--
        ) {
          if (
            horaAtual >=
            docasContext.armazemAtual.agendamentoDocasJanelas[i].horaInicio
          ) {
            selecionaJanela(i)
            break
          }
        }
      } else {
        selecionaJanela(0)
      }
    }
  }

  const selecionaJanela = (key: number) => {
    setJanelaSelecionada(key.toString())

    const cdJanela =
      docasContext.armazemAtual!.agendamentoDocasJanelas![key]
        .cdAgendamentoDocasJanela

    setDocasContext({
      ...docasContext,
      janelaAtual: cdJanela,
    })
  }

  return (
    <Tabs
      activeKey={janelaSelecionada}
      tabBarExtraContent={<Totais />}
      type="card"
      style={{ width: '100%' }}
      onTabClick={(key: string) => selecionaJanela(parseInt(key))}
    >
      {docasContext.armazemAtual?.agendamentoDocasJanelas?.map(
        (janela: IJanela, i) => {
          return (
            <TabPane tab={janela.nomeJanela} key={i}>
              <Janela
                key={`${janela.cdAgendamentoDocasArmazem}_${janela.cdAgendamentoDocasJanela}}`}
                cdJanela={janela.cdAgendamentoDocasJanela}
                atualizaAgenda={atualizaAgenda}
              />
            </TabPane>
          )
        },
      )}
    </Tabs>
  )
}

export default Agenda
